export const websiteTitle = "Hassan Rind";
export const websiteURL = "https://hassanrind.com";